import axios from "axios";

const axiosClient = axios.create({
  baseURL: "https://codematrix.co.in",
  // baseURL: "http://localhost:8080",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// REQUEST INTERCEPTOR
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },

  (error) => {
    return Promise.reject(error);
  },
);

// RESPONSE INTERCEPTOR
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },

  (error) => {
    console.log("ERROR STATUS:", error.response?.status);

    if (error.response?.status === 500) {
      window.location.href = "/servererror";
    }

    return Promise.reject(error);
  },
);

export default axiosClient;
